import { DiscountType } from "@/models/club";
import { DiscountWithCustomer } from "@/services/discount/type";
import { dateUtilities } from "@/utilities/helper/dateUtilities/dateUtilities";
import {
  Anchor,
  Badge,
  Card,
  Divider,
  Group,
  Stack,
  Text,
} from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";
import moment from "moment-jalaali";
import { useNavigate } from "react-router-dom";

type Props = {
  discount: DiscountWithCustomer;
};

function DiscountDetails({ discount }: Props) {
  const navigate = useNavigate();
  const goToUseDiscount = () => {
    navigate(`/dashboard/customers/details/${discount?.customer?.id}`, {
      state: { discount },
    });
  };

  return (
    <Card shadow="xs">
      <Stack>
        <Group justify="space-between">
          <Group gap="xs">
            <Text size="sm">کد تخفیف : </Text>
            <Text fw="800" size="sm" ff="arial">
              {discount?.code}
            </Text>
          </Group>
          <Badge size="sm">
            {discount?.discountType === DiscountType.Value0
              ? "تخفیف مبلغی"
              : "تخفیف درصدی"}
          </Badge>
        </Group>
        <Divider />
        {discount?.discountType === DiscountType.Value0 ? (
          <Group gap="xs">
            <Text size="sm">مبلغ تخفیف : </Text>
            <Text fw="800" c="green" size="sm">
              {discount?.amount?.toLocaleString()} ریال{" "}
            </Text>
          </Group>
        ) : (
          <Group gap="xs">
            <Text size="sm"> درصد تخفیف : </Text>
            <Text fw="800" c="green" size="sm">
              {discount?.percent?.toLocaleString()} %
            </Text>
          </Group>
        )}
        {discount?.minimumAmount && (
          <>
            <Divider />
            <Group gap="xs">
              <Text size="sm"> حداقل خرید : </Text>
              <Text fw="800" size="sm">
                {discount?.minimumAmount?.toLocaleString()} ریال{" "}
              </Text>
            </Group>
          </>
        )}
        {discount?.discountType === DiscountType.Value1 && (
          <>
            <Divider />
            <Group gap="xs">
              <Text size="sm">سقف تخفیف : </Text>
              <Text fw="800" size="sm">
                {discount?.maximumAmount?.toLocaleString()} ریال{" "}
              </Text>
            </Group>
          </>
        )}
        <Divider />
        <Stack gap="5">
          <Group gap="xs">
            <Text size="sm">تاریخ انقضا : </Text>
            <Text fw="800" size="sm">
              {moment(discount?.expireDate)
                .locale("fa")
                .format("jYYYY/jMM/jDD - HH:mm")}
            </Text>
          </Group>
          <Text size="xs" c="dimmed">
            {`  قابل استفاده تا ${dateUtilities.getRemainingDays(
              moment(discount?.expireDate).toDate()
            )} دیگر`}
          </Text>
        </Stack>

        <Divider />
        <Group justify="space-between">
          <Stack justify="center" align="center">
            <Text size="sm"> تعداد مجاز استفاده </Text>
            <Text fw="800" c="green" size="sm">
              {discount?.count}
            </Text>
          </Stack>
          <Divider orientation="vertical" />
          <Stack justify="center" align="center">
            <Text size="sm"> استفاده شده </Text>
            <Text fw="800" c="red" size="sm">
              {discount?.useCount}
            </Text>
          </Stack>
        </Group>
        <Divider />
        <Group justify="space-between">
          <Text size="sm">{discount?.customer?.phoneNumber}</Text>
          <Text size="sm">
            {discount?.customer?.firstName}
            {discount?.customer?.lastName}
          </Text>
        </Group>
        {discount?.isValid ? (
          <Anchor onClick={goToUseDiscount}>
            <Group gap="2" justify="end">
              <Text size="sm">استفاده از تخفیف</Text>
              <IconChevronLeft size="20px" />
            </Group>
          </Anchor>
        ) : (
          <Text size="sm" c="red">
            تخفیف منقضی شده است
          </Text>
        )}
      </Stack>
    </Card>
  );
}

export default DiscountDetails;
